"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateParentSelectionStates = exports.updateHierarchicalSelection = exports["default"] = exports.cancelPendingUpdates = void 0;
var _selectionUtils = require("./selectionUtils");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Updates parent selection states based on children selection
 */
var updateParentSelectionStates = exports.updateParentSelectionStates = function updateParentSelectionStates(allRows, selectedRowIds, explicitlyDeselectedIds) {
  var newSelectedSet = new Set(selectedRowIds);
  var newDeselectedSet = new Set(explicitlyDeselectedIds);

  // Get all potential parents
  var parentsWithChildren = allRows.filter(function (row) {
    return allRows.some(function (child) {
      return (0, _selectionUtils.getParentId)(child) === row.id;
    });
  });

  // Update all levels recursively until no more changes
  var changed = true;
  var iterations = 0;
  var maxIterations = 10; // Prevent infinite loops

  while (changed && iterations < maxIterations) {
    changed = false;
    iterations++;
    var _iterator = _createForOfIteratorHelper(parentsWithChildren),
      _step;
    try {
      var _loop = function _loop() {
        var parent = _step.value;
        var children = allRows.filter(function (child) {
          return (0, _selectionUtils.getParentId)(child) === parent.id;
        });
        if (children.length > 0) {
          var result = updateSingleParentState(parent, children, allRows, newSelectedSet, newDeselectedSet);
          if (result.hasChanged) {
            changed = true;
          }
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    newSelectedSet: newSelectedSet,
    newDeselectedSet: newDeselectedSet
  };
};

/**
 * Updates the selection state for a single parent based on its children
 */
var updateSingleParentState = function updateSingleParentState(parent, children, allRows, selectedRowIds, explicitlyDeselectedIds) {
  var hasChanged = false;

  // Calculate effective selection state for each child
  var effectivelySelectedChildren = children.filter(function (child) {
    // Child is effectively selected if:
    // 1. Not explicitly deselected AND
    // 2. (Directly selected OR inherits from any selected ancestor)
    if (explicitlyDeselectedIds.has(child.id)) return false;
    if (selectedRowIds.has(child.id)) return true;
    var childAncestors = (0, _selectionUtils.getAllAncestors)(child.id, allRows);
    return childAncestors.some(function (ancestorId) {
      return selectedRowIds.has(ancestorId);
    });
  });

  // Check if any child has indeterminate state
  var hasIndeterminateChildren = checkForIndeterminateChildren(children, allRows, selectedRowIds, explicitlyDeselectedIds);
  var selectionAnalysis = analyzeChildrenSelection(children, effectivelySelectedChildren, hasIndeterminateChildren, selectedRowIds);

  // Update parent based on children state
  if (selectionAnalysis.shouldSelectParent && !selectedRowIds.has(parent.id)) {
    selectedRowIds.add(parent.id);
    explicitlyDeselectedIds["delete"](parent.id);
    hasChanged = true;
  } else if (selectionAnalysis.shouldDeselectParent && selectedRowIds.has(parent.id)) {
    handleParentDeselection(parent, allRows, selectedRowIds, explicitlyDeselectedIds);
    hasChanged = true;
  } else if (selectionAnalysis.shouldMakeIndeterminate && selectedRowIds.has(parent.id)) {
    handleParentIndeterminate(parent, children, allRows, selectedRowIds, explicitlyDeselectedIds);
    hasChanged = true;
  }
  return {
    hasChanged: hasChanged
  };
};

/**
 * Check if any children have indeterminate state
 */
var checkForIndeterminateChildren = function checkForIndeterminateChildren(children, allRows, selectedRowIds, explicitlyDeselectedIds) {
  return children.some(function (child) {
    // Get child's direct descendants to check their selection state
    var childDescendants = (0, _selectionUtils.getAllDescendants)(child.id, allRows);
    if (childDescendants.length === 0) {
      // Leaf node - can't be indeterminate
      return false;
    }

    // Count effectively selected descendants - this is independent of whether child is explicitly deselected
    var effectivelySelectedDescendants = 0;
    var totalDescendants = childDescendants.length;
    var _iterator2 = _createForOfIteratorHelper(childDescendants),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var descendantId = _step2.value;
        if (explicitlyDeselectedIds.has(descendantId)) {
          // Explicitly deselected - not counted as selected
          return;
        }
        if (selectedRowIds.has(descendantId)) {
          // Directly selected
          effectivelySelectedDescendants++;
          return;
        }

        // Check if inherited from an ancestor (but not if that ancestor is also explicitly deselected)
        var descendantAncestors = (0, _selectionUtils.getAllAncestors)(descendantId, allRows);
        var hasSelectedAncestor = descendantAncestors.some(function (ancestorId) {
          return selectedRowIds.has(ancestorId) && !explicitlyDeselectedIds.has(ancestorId);
        });
        if (hasSelectedAncestor) {
          effectivelySelectedDescendants++;
        }
      }

      // Child is indeterminate if some but not all descendants are selected
      // This is independent of whether the child itself is explicitly deselected
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var isChildIndeterminate = effectivelySelectedDescendants > 0 && effectivelySelectedDescendants < totalDescendants;
    return isChildIndeterminate;
  });
};

/**
 * Analyze children selection to determine parent action
 */
var analyzeChildrenSelection = function analyzeChildrenSelection(children, effectivelySelectedChildren, hasIndeterminateChildren, selectedRowIds) {
  var allChildrenEffectivelySelected = effectivelySelectedChildren.length === children.length && children.length > 0;
  var allChildrenDirectlySelected = children.every(function (child) {
    return selectedRowIds.has(child.id);
  }) && children.length > 0;

  // A parent should only be fully selected if ALL children are directly selected AND no children are indeterminate
  var allChildrenSelected = allChildrenEffectivelySelected && allChildrenDirectlySelected && !hasIndeterminateChildren;

  // A parent should only be deselected if NO children are selected AND none are indeterminate
  var noChildrenSelected = effectivelySelectedChildren.length === 0 && !hasIndeterminateChildren;

  // A parent should be indeterminate if some (but not all) children are selected, OR if any child is indeterminate
  var someChildrenSelected = effectivelySelectedChildren.length > 0 && effectivelySelectedChildren.length < children.length || hasIndeterminateChildren || effectivelySelectedChildren.length > 0 && !allChildrenDirectlySelected;
  return {
    shouldSelectParent: allChildrenSelected,
    shouldDeselectParent: noChildrenSelected,
    shouldMakeIndeterminate: someChildrenSelected
  };
};

/**
 * Handle parent deselection logic
 */
var handleParentDeselection = function handleParentDeselection(parent, allRows, selectedRowIds, explicitlyDeselectedIds) {
  var parentAncestors = (0, _selectionUtils.getAllAncestors)(parent.id, allRows);
  var hasSelectedParentAncestor = parentAncestors.some(function (ancestorId) {
    return selectedRowIds.has(ancestorId);
  });
  if (hasSelectedParentAncestor) {
    explicitlyDeselectedIds.add(parent.id);
  } else {
    selectedRowIds["delete"](parent.id);
  }

  // When removing a parent, also remove descendants that were only selected through inheritance
  var descendants = (0, _selectionUtils.getAllDescendants)(parent.id, allRows);
  var _iterator3 = _createForOfIteratorHelper(descendants),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var descendantId = _step3.value;
      // Only remove descendants that don't have other selected ancestors
      var descendantAncestors = (0, _selectionUtils.getAllAncestors)(descendantId, allRows);
      var hasOtherSelectedAncestor = descendantAncestors.some(function (ancestorId) {
        return ancestorId !== parent.id && selectedRowIds.has(ancestorId);
      });
      if (!hasOtherSelectedAncestor) {
        selectedRowIds["delete"](descendantId);
        explicitlyDeselectedIds["delete"](descendantId);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
};

/**
 * Handle parent indeterminate state logic
 */
var handleParentIndeterminate = function handleParentIndeterminate(parent, children, allRows, selectedRowIds, explicitlyDeselectedIds) {
  // Explicitly select the children that should remain selected
  var childrenToKeepSelected = children.filter(function (child) {
    return !explicitlyDeselectedIds.has(child.id);
  });
  var _iterator4 = _createForOfIteratorHelper(childrenToKeepSelected),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var child = _step4.value;
      // Add remaining children to selected set
      selectedRowIds.add(child.id);
    }

    // Remove parent from selected
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var parentAncestors = (0, _selectionUtils.getAllAncestors)(parent.id, allRows);
  var hasSelectedParentAncestor = parentAncestors.some(function (ancestorId) {
    return selectedRowIds.has(ancestorId);
  });
  if (hasSelectedParentAncestor) {
    explicitlyDeselectedIds.add(parent.id);
  } else {
    selectedRowIds["delete"](parent.id);
  }
};

// Keep track of pending updates to cancel them if needed
var pendingUpdateId = null;

/**
 * Cancel any pending hierarchical updates
 */
var cancelPendingUpdates = exports.cancelPendingUpdates = function cancelPendingUpdates() {
  if (pendingUpdateId !== null) {
    clearTimeout(pendingUpdateId);
    pendingUpdateId = null;
  }
};

/**
 * Main function to handle hierarchical selection updates
 */
var updateHierarchicalSelection = exports.updateHierarchicalSelection = function updateHierarchicalSelection(rowId, selected, allRows, selectedRowIds, explicitlyDeselectedIds, onSelectionUpdate) {
  // Cancel any pending updates to prevent conflicts
  cancelPendingUpdates();

  // Handle immediate selection/deselection
  var newSelectedSet = new Set(selectedRowIds);
  var newDeselectedSet = new Set(explicitlyDeselectedIds);
  if (selected) {
    // When selecting: add this row to selected
    newSelectedSet.add(rowId);
    // Remove this row and descendants from explicitly deselected
    newDeselectedSet["delete"](rowId);
    var descendants = (0, _selectionUtils.getAllDescendants)(rowId, allRows);
    var _iterator5 = _createForOfIteratorHelper(descendants),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var id = _step5.value;
        newDeselectedSet["delete"](id);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } else {
    // When deselecting: remove this row and all its descendants from selected
    newSelectedSet["delete"](rowId);
    var _descendants = (0, _selectionUtils.getAllDescendants)(rowId, allRows);
    var _iterator6 = _createForOfIteratorHelper(_descendants),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _id = _step6.value;
        newSelectedSet["delete"](_id);
      }

      // Check if any ancestor is selected
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    var ancestors = (0, _selectionUtils.getAllAncestors)(rowId, allRows);
    var hasSelectedAncestor = ancestors.some(function (ancestorId) {
      return selectedRowIds.has(ancestorId);
    });
    if (hasSelectedAncestor) {
      newDeselectedSet.add(rowId);
    }

    // When deselecting a parent, remove descendants from explicitly deselected
    var _iterator7 = _createForOfIteratorHelper(_descendants),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _id2 = _step7.value;
        newDeselectedSet["delete"](_id2);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }

  // First update with immediate changes
  onSelectionUpdate(newSelectedSet, newDeselectedSet);

  // Then update ancestors with cancellation tracking
  pendingUpdateId = setTimeout(function () {
    // Only proceed if this update hasn't been cancelled
    if (pendingUpdateId !== null) {
      var finalResult = updateParentSelectionStates(allRows, newSelectedSet, newDeselectedSet);
      onSelectionUpdate(finalResult.newSelectedSet, finalResult.newDeselectedSet);
      pendingUpdateId = null;
    }
  }, 0);
};
var _default = exports["default"] = updateHierarchicalSelection;